import { Box, Container, Typography, IconButton } from "@mui/material";
import { useState } from "react";
import { useQuery } from "react-query";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Iconify from "src/components/Iconify";
import Page from "src/components/Page";
import useSettings from "src/hooks/useSettings";
import { getAllDeliveryOrder } from "src/pages/api";
import { PATH_DASHBOARD } from "src/routes/paths";
import AddRider from "./Add";
import WithoutPagination from "src/components/mrt-table/WithoutPagination";
import Label from "src/components/Label";
// import DeleteRecord from "../../DeleteRecord";

export const getStatusColor = (status) => {
  const error = [
    "Cancelled",
    "Refund",
    "Payment Initiated",
    "Payment Failed",
    "RTO",
  ];
  const warning = ["Partial Delivered", "Pending", "Processing"];
  const info = ["Delivered"];
  if (status) {
    if (error.includes(status)) {
      return "error";
    }
    if (warning.includes(status)) {
      return "primary";
    }
    if (info.includes(status)) {
      return "info";
    }
    return "success";
  }
  return "success";
};

const columns = [
  {
    accessorKey: "status",
    header: "Status",
    Cell: ({ renderedCellValue, row }) => (
      <Label variant={"ghost"} color={getStatusColor(row?.original?.status)}>
        {renderedCellValue}
      </Label>
    ),
  },
  {
    accessorKey: "orderID",
    header: "Order ID",
  },
  {
    accessorKey: "FullName",
    header: "Customer Name",
  },
  {
    accessorKey: "packageName",
    header: "packageName",
  },
  {
    accessorKey: "Address",
    header: "Address",
  },

  {
    accessorKey: "rider_name",
    header: "Rider",
  },
  {
    accessorKey: "rider_mobile",
    header: "Rider Mobile",
  },
];

export default function OrderToDeliver() {
  const { themeStretch } = useSettings();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const { data, isLoading } = useQuery({
    queryKey: ["getAllDeliveryOrder"],
    queryFn: getAllDeliveryOrder,
  });

  return (
    <>
      {open && (
        <AddRider
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
          }}
          row={selectedRow}
        />
      )}

      <Page title="Courier">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <HeaderBreadcrumbs
            heading={`Order To Deliver`}
            links={[
              { name: "Dashboard", href: PATH_DASHBOARD.root },
              {
                name: "Courier",
              },
              { name: "Order" },
            ]}
          />
          {/* <Grid container spacing={3}>
            <Grid item xs={12} lg={12}> */}
          <Box sx={{ minWidth: 3000 }}>
            <WithoutPagination
              data={data || []}
              columns={columns}
              loading={isLoading}
              // manualPagination={true}
              // pagination={pagination}
              // rowCount={data?.count || 0}
              // onPaginationChange={setPagination}
              renderRowActions={({ row }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    onClick={() => {
                      setOpen(true);
                      setSelectedRow(row.original);
                    }}
                    disabled={
                      row.original.status === "Delivered" ||
                      row.original.status === "Out For Delivery"
                    }
                  >
                    <Iconify icon={"ic:baseline-delivery-dining"} />
                  </IconButton>
                </Box>
              )}
              renderTopToolbarCustomActions={() => (
                <Typography variant="h5">Order To Deliver</Typography>
              )}
            />
          </Box>
          {/* </Grid>
          </Grid> */}
        </Container>
      </Page>
    </>
  );
}
